import i18n from '@/i18n'
import Index from './index.vue'
import { COMPANY_PAGE_TYPE } from '@/constant/company'

export default {
  path: `/recruiting/company/:companyId/:page(${COMPANY_PAGE_TYPE.BRANDING}|${COMPANY_PAGE_TYPE.LANDING})`,
  component: Index,
  meta: {
    noAuth: true,
    title: i18n.t('company.label.title')
  }
}
